import data from './pictorialBar.data'
import itemStyle from './pictorialBar.itemStyle'
import emphasis from './pictorialBar.emphasis'
import label from './pictorialBar.label'
import tooltip from './pictorialBar.tooltip'

export default {
  name: "pictorialBar",
  nickname: "象形柱图",
  desc: "pictorialBar",
  type: "object",
  props: {
    name: {
      name: "name",
      nickname: "名称",
      desc:
        '系列名称，用于<a target="__blank" href="https://echarts.apache.org/zh/option.html#tooltip">tooltip</a>的显示，<a target="__blank" href="https://echarts.apache.org/zh/option.html#legend">legend</a> 的图例筛选，在 <code class="codespan">setOption</code> 更新数据和配置项时用于指定对应的系列。',
    },
    barWidth: {
      name: "barWidth",
      nickname: "柱条宽度",
      desc: "柱条的宽度，不设时自适应。",
      value: "",
      defaultValue: "",
      type: "pureValue",
    },
    barGap: {
      name: "barGap",
      nickname: "不同系列的柱间距离",
      desc:
        '不同系列的柱间距离，为百分比（如 <code class="codespan">&#39;30%&#39;</code>，表示柱子宽度的 <code class="codespan">30%</code>）。',
      value: "-100%",
      defaultValue: "-100%",
      type: "pureValue",
    },
    barCategoryGap: {
      name: "barCategoryGap",
      nickname: "同一系列的柱间距离，",
      desc: "同一系列的柱间距离，默认为类目间距的20%，可设固定值",
      value: "20%",
      defaultValue: "20%",
      type: "pureValue",
    },
    z: {
      name: "z",
      nickname: "z",
      desc:
        '象形柱图组件的所有图形的<code class="codespan">z</code>值。控制图形的前后顺序。<code class="codespan">z</code>值小的图形会被<code class="codespan">z</code>值大的图形覆盖。',
      value: 2,
      defaultValue: 2,
      type: "pureValue",
    },
    data,
    itemStyle,
    emphasis,
    label,
    tooltip,
    symbolPosition: {
      name: "symbolPosition",
      nickname: "图形的定位位置",
      desc: "图形的定位位置。可取值：",
      value: "start",
      defaultValue: "start",
      type: "pureValue",
    },
    symbolOffset: {
      name: "symbolOffset",
      nickname: "箭头偏移",
      desc:
        '图形相对于原本位置的偏移。<code class="codespan">symbolOffset</code> 是图形定位中最后计算的一个步骤，可以对图形计算出来的位置进行微调。',
      value: [0, 0],
      defaultValue: [0, 0],
      type: "pureValue",
    },
    symbolSize: {
      name: "symbolSize",
      nickname: "箭头大小",
      desc: "图形的大小。",
      value: ["100%", "100%"],
      defaultValue: ["100%", "100%"],
      type: "pureValue",
    },
    type: {
      name: "type",
      nickname: "类型",
      desc: "type",
      value: "",
      defaultValue: "",
      type: "pureValue",
    },
  },
}
